import { gsap } from "gsap";
import { animateObserver, fadeIn } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";

(() => {
  const BRHSlideLauncher = () => {
    const selectors = {
      component: "brh-slide-launcher",
    };

    const init = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          const swiperElement = element?.querySelector(".swiper");
          if (swiperElement) {
            [...element.querySelector(".swiper-wrapper").children].forEach((element) => {
              element.classList.add("swiper-slide");
            });

            new window.Swiper(element.querySelector(".swiper"), {
              slidesPerView: 1,
              freeMode: false,
              loop: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });
          }
        });
      }

      //== Animations
      if (!isMobile() && !isAuthor()) {
        const carousels = document.querySelectorAll(`.${selectors.component}`);
        if (carousels.length > 0) {
          carousels?.forEach((element) => {
            const wrappers = element.querySelectorAll(".swiper-wrapper");
            const appearances = gsap.timeline();
            wrappers.length > 0 && appearances.add(fadeIn({ classElement: wrappers, duration: 2 }), 0);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHSlideLauncher);
})();
